export class ValidationMessages {
  public FormArrays: {
    [key: string]:
    {
      [key: string]: { [key: string]: string }
    }
  } = {};

  Fetch(array: string, node: number, key: string): string {

    var arrayNode = this.FormArrays[array];

    if (arrayNode == null)
      return null;

    if (arrayNode[node.toString()] == null)
      return null;

    return arrayNode[node.toString()][key.toString()];
  }

  public Messages: { [key: string]: string } = {};
}


export class ValidationRules {

  constructor() {
    this.Messages = {};
  }

  public Messages: {
    [key: string]: { [key: string]: string }
  };

  public FormArrays:
    {
      [key: string]:
      {
        [key: string]: { [key: string]: string }
      }
    } = {};
}
